(function (jQuery) {
  jQuery.gfGuide = function (element, options) {
    const defaults = {};
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      return false;
    };

    this.showMessage = function (message) {
      $element.children('#gf_guide-content').html(message);
      return _this;
    };

    this.setPosition = function (xPos, yPos) {
      $element.css({
        left: xPos,
        top: yPos,
      });
      return _this;
    };

    this.init();
  };
  jQuery.fn.gfGuide = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfguide')) {
        const plugin = new jQuery.gfGuide(this, options);
        jQuery(this).data('gfguide', plugin);
      }
    });
  };
})(jQuery);
